import React from 'react';
import type { IconProps } from '../types';

/** Bolt icon for too-fast / outlier studies. */
export const OutlierBolt = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13 3.5 4.5 14.25h6.38l-1.13 6.75L19.5 9.75H13.13L13 3.5Z"
    />
  </svg>
);

export default OutlierBolt;
